
import React, { useState } from 'react';
import Layout from '@/components/layout/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import OptimizedWarehousePendingList from '@/components/warehouse/OptimizedWarehousePendingList';
import OptimizedWarehouseConfirmedList from '@/components/warehouse/OptimizedWarehouseConfirmedList';
import OptimizedWarehouseRejectedList from '@/components/warehouse/OptimizedWarehouseRejectedList';
import WarehouseUpcomingList from "@/components/warehouse/WarehouseUpcomingList";

const Warehouse = () => {
  const [pendingCount, setPendingCount] = useState(0);

  return (
    <Layout fullWidth>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Warehouse Management</h1>
          <p className="text-muted-foreground">
            Manage procurement inspections, confirmations, and rejections
          </p>
        </div>

        <Tabs defaultValue="pending" className="space-y-4">
          <TabsList>
            <TabsTrigger value="pending" className="relative">
              Pending Review
              {pendingCount > 0 && (
                <Badge variant="destructive" className="ml-2 px-1 py-0 text-xs">
                  {pendingCount}
                </Badge>
              )}
            </TabsTrigger>
            <TabsTrigger value="confirmed">Confirmed</TabsTrigger>
            <TabsTrigger value="rejected">Rejected</TabsTrigger>
            <TabsTrigger value="upcoming">Upcoming</TabsTrigger>
          </TabsList>

          <TabsContent value="pending" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  Pending Warehouse Review
                  {pendingCount > 0 && (
                    <Badge variant="secondary">
                      {pendingCount} pending
                    </Badge>
                  )}
                </CardTitle>
                <CardDescription>
                  Procurements awaiting warehouse inspection and confirmation
                </CardDescription>
              </CardHeader>
              <CardContent>
                <OptimizedWarehousePendingList onCountChange={setPendingCount} />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="confirmed" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>Confirmed Procurements</CardTitle>
                <CardDescription>
                  Procurements that have been confirmed by warehouse
                </CardDescription>
              </CardHeader>
              <CardContent>
                <OptimizedWarehouseConfirmedList />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="rejected" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>Rejected Procurements</CardTitle>
                <CardDescription>
                  Procurements that have been rejected by warehouse
                </CardDescription>
              </CardHeader>
              <CardContent>
                <OptimizedWarehouseRejectedList />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="upcoming" className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>Upcoming Procurements</CardTitle>
                <CardDescription>
                  Procurements scheduled for delivery in the future
                </CardDescription>
              </CardHeader>
              <CardContent>
                <WarehouseUpcomingList />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default Warehouse;
